function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "320px",
    height: "320px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#ffd701",
    d: "M 141.5,4.5 C 208.454,0.224715 259.621,26.2247 295,82.5C 316.064,122.034 320.398,163.367 308,206.5C 285.923,268.236 242.423,304.069 177.5,314C 110.506,318.755 59.3397,292.921 24,236.5C 2.93568,196.966 -1.39766,155.633 11,112.5C 33.2469,50.748 76.7469,14.748 141.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffefe",
    d: "M 190.5,191.5 C 190.783,192.289 191.283,192.956 192,193.5C 192.5,152.168 192.667,110.835 192.5,69.5C 207.167,69.5 221.833,69.5 236.5,69.5C 236.5,130.167 236.5,190.833 236.5,251.5C 218.923,251.825 201.423,251.492 184,250.5C 162.22,209.938 140.72,169.271 119.5,128.5C 119.217,127.711 118.717,127.044 118,126.5C 117.5,168.165 117.333,209.832 117.5,251.5C 102.833,251.5 88.1667,251.5 73.5,251.5C 73.5,190.833 73.5,130.167 73.5,69.5C 91.1792,69.1671 108.846,69.5005 126.5,70.5C 148.101,110.702 169.434,151.035 190.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe248",
    d: "M 192.5,69.5 C 192.667,110.835 192.5,152.168 192,193.5C 191.283,192.956 190.783,192.289 190.5,191.5C 191.167,150.833 191.833,110.167 192.5,69.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffeb80",
    d: "M 119.5,128.5 C 118.833,169.5 118.167,210.5 117.5,251.5C 117.333,209.832 117.5,168.165 118,126.5C 118.717,127.044 119.217,127.711 119.5,128.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0059889cdabb2b9865f1180456cd8337.svg";
export { ForwardRef as ReactComponent };